import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Graph from './SimpleLineChart';
import SimpleTable from './SimpleTable';
import CustomizedSlider from './slider';
import SimpleForm from './SimpleForm';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="Profits over time" {...a11yProps(0)} />
          <Tab label="Diversity Matrix" {...a11yProps(1)} />
          <Tab label="Diversity Aggregator" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <div  className="data">
      <TabPanel value={value} index={0}>
        <h1>Profits over time</h1>
      <Graph />
      <br />
        <h1>Diversity Index</h1>
        <CustomizedSlider />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <h1>Employee Diversity Matrix</h1>
      <SimpleTable />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <SimpleForm />
      </TabPanel>
      </div>
    </div>
  );
}
